export const deviceLogs = {
    method: 'POST',
    paths: ['/remoteDiagnostic/deviceLogs'],
    fields: {
        locationName: {
            type: 'keyString',
            required: true,
        },
        locationId: {
            type: 'mongoId',
        },
        logs: {
            type: 'longString',
            required: true,
        },
    },
};
//# sourceMappingURL=remote_diagnostic_device_logs.js.map